// The clock of a live match, as 365scores sends it (backend routes/agenda.py `minuto`, `estado`), written for a reader.
// Each sport sends it differently (10 Oct 2026, three matches live at once):
// - football: «39'» — the apostrophe is already there; the cards added a second one («39''»);
// - handball: «15.92» — minutes played, with a decimal fraction;
// - basketball: «09:25» — the quarter clock, with the quarter in `estado` («1C»).
const QUARTER = { 1: '1.er cuarto', 2: '2.º cuarto', 3: '3.er cuarto', 4: '4.º cuarto' };

/** The period in words: «1C» → «1.er cuarto»; anything else as 365scores wrote it. */
export function liveEstado(m) {
  const estado = String(m?.estado || '').trim();
  const q = /^([1-4])\s*C$/i.exec(estado);
  return q ? QUARTER[q[1]] : estado;
}

/** The badge on a live card: «39'», «45+2'», «15'», «09:25»; '' when there is nothing to show. */
export function liveClock(m) {
  const raw = String(m?.minuto ?? '').trim().replace(/['’"]+$/, '');
  if (!raw) return '';
  // Basketball: the clock alone; the quarter is on the period line under the score (liveEstado).
  if (/^\d{1,2}:\d{2}$/.test(raw)) return raw;
  if (/^\d+\.\d+$/.test(raw)) return `${Math.floor(Number(raw))}'`;
  if (/^\d+(\+\d+)?$/.test(raw)) return `${raw}'`;
  return raw;
}
